import { Component, DoCheck, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { DropDownMenuItem } from './dropdown-menu-item';

@Component({
  selector: 'nec-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss']
})
export class NecDropDownMenuComponent implements OnInit, OnChanges, DoCheck {
  @Input() buttonWidth = '98px';
  @Input() currentChosenDropDownMenuItem: DropDownMenuItem;
  @Input() defaultText = 'è¯·éæ©';
  @Input() defaultChosenFirstItem = false;
  @Input() dropDownMenuWidth = '98px';
  @Input() dropDownMenuMaxHeight = '150px';
  @Input() dropDownMenuItems: DropDownMenuItem[];
  @Input() disableSet: Set<number>;
  @Input() dropDownMenuPosition = 'absolute'; // absolute || fixed
  @Input() btnId = '';
  @Output() chosenMenuItemChange: EventEmitter<DropDownMenuItem> = new EventEmitter<DropDownMenuItem>();
  showMenu = false;
  top = 'auto';
  left = 'auto';
  timer = null;

  ngOnInit() {
    if (this.defaultChosenFirstItem) {
      this.currentChosenDropDownMenuItem = this.dropDownMenuItems.find(item => item.show);
      if (this.currentChosenDropDownMenuItem) {
        this.currentChosenDropDownMenuItem.chosen = true;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName === 'dropDownMenuItems') {
        if (this.currentChosenDropDownMenuItem) {
          this.currentChosenDropDownMenuItem.disable = false;
          this.currentChosenDropDownMenuItem.chosen = true;
        }
      }
    }
  }

  ngDoCheck() {
    if (this.dropDownMenuItems && this.disableSet) {
      for (let item of this.dropDownMenuItems) {
        item.disable = this.disableSet.has(item.id);
      }
    }
  }

  menuItemClick(currentDropDownMenu: DropDownMenuItem) {
    if (currentDropDownMenu.disable || currentDropDownMenu.chosen) {
      return;
    }
    this.dropDownMenuItems.forEach(item => item.chosen = false);
    currentDropDownMenu.chosen = true;
    this.currentChosenDropDownMenuItem = currentDropDownMenu;
    this.chosenMenuItemChange.emit(currentDropDownMenu);
  }

  buttonClick() {
    this.showMenu = !this.showMenu;
    if (this.dropDownMenuPosition === 'fixed') {
      this.getBoundingClientRect();
      this.timer = setInterval(() => {
        this.getBoundingClientRect();
      }, 1000);
    }
  }

  getBoundingClientRect() {
    let boundingClientRect = document.getElementById(this.btnId).getBoundingClientRect() as DOMRect;
    this.top = (boundingClientRect.y + boundingClientRect.height) + 'px';
    this.left = boundingClientRect.x + 'px';
  }

  onMouseLeave() {
    this.showMenu = false;
    if (this.dropDownMenuPosition === 'fixed') {
      clearInterval(this.timer);
    }
  }

}
